import { render, staticRenderFns } from "./MyLifecycleTickets.vue?vue&type=template&id=6d24cf95&"
import script from "./MyLifecycleTickets.vue?vue&type=script&lang=js&"
export * from "./MyLifecycleTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports